/**
 * Height and width of the tooltip pointer in pixels
 */
export const TOOLTIP_POINTER_SIZE = 15;
